<!--
    Drugi Panel (mail, download, etc.)
-->

<i18n>
    {
    "en": {
    "share": "SHARE THE CONFIGURATION",
    "download": "DOWNLOAD THE CONFIGURATION",
    "brochure": "DOWNLOAD THE BROCHURE",
    "mail_subject": "Siniat - CREATEX Helix - My configuration : ",
    "mail_body": "Here is the configuration I created with the Siniat CREATEX configurator: "
    },

    "fr": {
    "share": "PARTAGEZ LA CONFIGURATION",
    "download": "TELECHARGEZ LA CONFIGURATION",
    "brochure": "TELECHARGEZ LA BROCHURE",
    "mail_subject": "Siniat - CREATEX Helix - Ma configuration : ",
    "mail_body": "Voici la configuration que je viens de réaliser avec l'outil de configuration CREATEX de Siniat: "
    },

    "pl": {
    "share": "UDOSTĘPNIJ KONFIGURACJĘ",
    "download": "POBIERZ KONFIGURACJĘ",
    "brochure": "POBIERZ BROSZURĘ",
    "mail_subject": "Siniat - CREATEX Helix - Moja specyfikacja : ",
    "mail_body": "Tutaj znajdziesz specyfikację projektu, którą utworzyłeś za pomocą konfiguratora Siniat CREATEX: "
    },

    "de": {
    "share": "TAILEN DIE CONFIGURATION",
    "download": "LADEN DIE CONFIGURATION",
    "brochure": "LADEN DIE BROCHURE",
    "mail_subject": "Siniat - CREATEX Helix - Meine Konfiguration : ",
    "mail_body": "Hier ist meine Konfiguration aus dem CREATEX-Konfigurator: "
    }

    }
</i18n>

<template>
    <div class="SecondPanel">
        <!--<a :href="generateMailto()">MAIL</a>-->
        <!--<button class="location" :title="$t('Localisation')"><br /></button>-->
        <button class="mail" :title="$t('share')" @click="sendmail()">
            <img src="@/assets/icons/icon_share.png" alt="mail" />
            <span>
                {{ $t('share') }}
            </span>
        </button>
        <button class="download" :title="$t('download')" @click="download()">
            <img src="@/assets/icons/icon_download.png" alt="mail" />
            <span>
                {{ $t('download') }}
            </span>
        </button>
        <button class="document" :title="$t('brochure')" @click="brochure()">
            <img src="@/assets/icons/icon_document.png" alt="mail" />
            <span>
                {{ $t('brochure') }}
            </span>
        </button>
    </div>
</template>

<script>

    export default {
        name: 'SecondPanel',

        props: {
            scene: String,
        },
        data() {
            return {
            }
        },
        computed: {
            // Only scene name without position (a or b)
            sceneRoot: function () {
                return this.scene.slice(0, -2);
            },
            shareLink: function () {
                return window.location.host + "/" + this.scene + "#/?lang=" + this.$i18n.locale;
            },
            downloadPath: function () {
                return "http://" + window.location.host + "/downloads/" + this.$i18n.locale + "/" + this.sceneRoot + ".pdf";
            },
            brochurePath: function () {
                return "http://" + window.location.host + "/downloads/" + this.$i18n.locale + "/" + "CREATEX_Helix_brochure.pdf";
            },
            mailto: function () {
                let mailto = "mailto:" +
                    "?subject=" + this.$t('mail_subject') + this.sceneRoot +
                    "&body=" + this.$t('mail_body') + encodeURIComponent("http://" + this.shareLink);
                    //encodeURIComponent("<a href=\"http://" + this.shareLink + "\">" + this.shareLink + "</a>");
                    // NIE DA SIĘ BO: https://www.ietf.org/rfc/rfc6068.txt
                return mailto;
            }
        },
        components: {

        },
        methods: {
            sendmail: function () {
                //console.log(this.mailto);
                //window.location.assign(this.mailto);
                let win = window.open(this.mailto, '_blank');
                win.focus();
            },
            download: function () {
                //window.location.assign(this.downloadPath);
                let win = window.open(this.downloadPath, '_blank');
                win.focus();
            },
            brochure: function () {
                //window.location.assign(this.brochurePath);
                let win = window.open(this.brochurePath, '_blank');
                win.focus();
            }
        }
    };
</script>

<style scoped>
    .SecondPanel {
        position: absolute;
        bottom: 0;
        right: 0;
        display: inline-flex;
        text-align: right;
        width: 100%;
        height: 60px;
        vertical-align: top;
        z-index: 10;
        border-top: 1px solid #FFF;
        justify-content: space-between;
        background: #FFF;
    }

    button {
        background-color: #434D56;
        color: #FFF;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
        display: inline-block;
        flex-basis: 33.25%;
        align-items: center;
        /*width: calc(33% - 1px);*/
        height: 100%;
        vertical-align: middle;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: clip;
        transition: all 0.4s ease;
        box-shadow: inset -1px 1px 1px rgba(0, 0, 0, 0);
    }

        button:not(:disabled):hover {
            box-shadow: inset 0 0 14px 0px rgba(0, 0, 0, 0.5);
        }

        button span {
            font-size: 0.7rem;
            padding: 0.5rem;
        }

        button img {
            /*width: 20%;*/
            max-height: 100%;
            vertical-align: middle;
            object-fit: contain;
        }

    @media only screen and (max-device-width : 1150px) {
        button img {
            display: none;
        }
    }

    @media only screen and (max-device-width : 1024px) {
        button img {
            display: inline-block;
            width: 100%;
        }

        button span {
            display: none;
        }
    }
</style>